var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComment24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 19.664c0-.514-.39-.936-.9-1.009-.867-.124-1.464-.32-2.138-.873a4.952 4.952 0 0 1-.788-.87c-.674-1.008-.674-1.972-.674-3.9V8.988c0-1.928 0-2.892.674-3.9.176-.264.543-.67.788-.87.938-.77 1.727-.848 3.304-1.003A48.43 48.43 0 0 1 12 3c1.876 0 3.446.088 4.734.215 1.577.155 2.365.233 3.303 1.003.246.2.613.606.789.87.674 1.008.674 1.972.674 3.9v4.024c0 1.928 0 2.892-.674 3.9a4.955 4.955 0 0 1-.788.87c-.939.77-1.727.848-3.304 1.003-.615.06-1.294.112-2.04.15a4.174 4.174 0 0 0-2.43.912L9.408 22.17A1.476 1.476 0 0 1 7 21.024v-1.36Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment24);
export default __webpack_public_path__ + "static/media/comment_24.e9c37434.svg";
export { ForwardRef as ReactComponent };